import { FC } from "react";
import { MarketplaceCategory } from "../types";

type CategoryButtonsProps = {
  categories: MarketplaceCategory[];
  selectedCategoryId: number | null;
  onCategoryClick: (categoryId: number | null) => void;
};

const CategoryButtons: FC<CategoryButtonsProps> = ({
  categories,
  selectedCategoryId,
  onCategoryClick,
}) => {
  const onClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    const categoryId = event.currentTarget.dataset.categoryId;
    onCategoryClick(categoryId ? Number(categoryId) : null);
  };

  return (
    <div className="marketplace-category-wrapper">
      <button
        key="all"
        data-testid="marketplace-all-categories"
        data-category-id=""
        className={`button ${selectedCategoryId === null ? "button--orange" : "button--bordered--secondary"}`}
        onClick={onClick}
      >
        All
      </button>
      {categories.map((category) => {
        return (
          <button
            key={category.id}
            data-category-id={category.id}
            className={`margin-left-10 button ${selectedCategoryId === category.id ? "button--orange" : "button--bordered--secondary"}`}
            onClick={onClick}
          >
            {category.name}
          </button>
        );
      })}
    </div>
  );
};

export default CategoryButtons;
